import React, { ReactNode } from 'react';
import {
  Panel,
  PanelHeader,
  PanelContent,
  PanelFooter,
  SkipLink,
  PanelFooterColumn,
} from '@flixbus/honeycomb-react';
import * as styles from './DateMobilePanel.scss';
import { ConfirmButton } from 'app/components/ui/ConfirmButton/ConfirmButton';
import { useTranslations } from 'app/hooks/useTranslations';
import { a11yLabelsKeys } from 'app/providers/a11yLabels';

export const DateMobilePanel = ({
  isActive,
  children,
  onClose,
  title,
}: {
  isActive: boolean;
  children: ReactNode;
  onClose: () => void;
  title: string;
}) => {
  const { getSkipLinkLabel, getCloseLabel } = useTranslations({
    getSkipLinkLabel: 'search_mask.calendar_skip_link_text',
    getCloseLabel: a11yLabelsKeys.close,
  });

  if (!isActive) return null;

  return (
    <Panel
      extraClasses={styles.panelWrapper}
      id="mobile-date-panel"
      active={isActive}
      position="bottom"
      fullSize
      hasOverlay
      onOverlayClick={onClose}
      aria-live="polite"
    >
      <PanelHeader
        closeButtonProps={{
          label: getCloseLabel(),
          onClick: onClose,
          id: 'close-button',
        }}
        extraClasses={styles.panelHeader}
      >
        {title}
      </PanelHeader>
      <PanelContent extraClasses={styles.panelContent}>
        <SkipLink
          onClick={(e) => {
            const button: HTMLDivElement | null = document.querySelector('[role="grid"] button');
            button?.focus();
            e.preventDefault();
          }}
          extraClasses={styles.skipLink}
          to=""
        >
          {getSkipLinkLabel()}
        </SkipLink>
        {children}
      </PanelContent>
      <PanelFooter extraClasses={styles.panelFooter}>
        <PanelFooterColumn>
          <ConfirmButton id="confirm-date-button" onClick={onClose} />
        </PanelFooterColumn>
      </PanelFooter>
    </Panel>
  );
};
